export default __webpack_public_path__ + "static/media/Trustpilot-logo.87b77df1.png";